export default __webpack_public_path__ + "static/media/Icon-paperclip.1293fd76.svg";